import React from 'react'
import { usePostRequest } from '../hooks/request'
import { MANTHLY_INCOME_TAX_ITEM_LIST } from '../urls'
import ManthlyIncomeTaxItemForm from './ManthlyIncomeTaxItemForm'

export default function ManthlyIncomeTaxItemCreate({ onCancel, onSuccess, finance, incomeTaxId }) {
    const monthCreate = usePostRequest({ url: MANTHLY_INCOME_TAX_ITEM_LIST.replace('{incomeTaxId}', finance.id) })

    async function onSubmit(data) {
        const { success } = await monthCreate.request({ data })

        if (success) {
            onSuccess()
        }
    }

    return (
        <div>
            <b>Добавить</b><br /><br />
            <ManthlyIncomeTaxItemForm
                finance={finance}
                incomeTaxId={incomeTaxId}
                onSubmit={onSubmit}
                onCancel={onCancel}
                loading={monthCreate.loading} />
        </div>
    )
}
